import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { SystemUpgradeState } from 'src/app/shared/services/ump';
import { selectSystemUpgrade } from 'src/app/stores/global';

@Component({
  selector: 'frodo-system-upgrade',
  templateUrl: './system-upgrade.component.html',
  styleUrls: ['./system-upgrade.component.scss'],
})
export class SystemUpgradeComponent {
  readonly systemUpgrade$ = this.store.select(selectSystemUpgrade);
  readonly systemUpgradeState = SystemUpgradeState;

  constructor(private store: Store) {}
}
